import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getCurrencyQuery = () => {
  return axios.get(apiurl?.getCurrency);
};

const getCurrencyList = () => {
  return useQuery(['getCurrencyList'], () => getCurrencyQuery(), { refetchOnWindowFocus: false });
};

export default getCurrencyList;
